import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../static/images/logo.png';

let Logo = (props: any) => {
   return (
     <Link to="/">
      <img src={logo} className="App-logo" alt="logo" onClick = { (event) => {
        // props.history.push({
        //   pathname: '/',
        //   state: {
        //     user: {}
        //   }
        // });              
      }}/>
    </Link>
  )
}

export default Logo;



